import * as React from 'react';

import styles from  './Footer.module.scss';
import logo from '../../assets/img/token-logo-logo-lockup-white.svg';

export class Footer extends React.Component<{},{}> {
    render() {
        return (
            <div className={styles.footer}>
                <img src={logo} alt={logo} />
                <div className={styles.links}>
                    <a href='https://hachette.sharepoint.com/sites/ThemisGuidesandFAQ/'>FAQs & How to</a>
                    <span className={styles.separator}>|</span>
                    <a href='https://hachette.sharepoint.com/sites/ThemisGuidesandFAQ/'>Help</a>
                </div>
            </div>
        )
    }
}